<template>
  <div>
    <select
        id="input-holder"
        :ref="'input-holder'"
        @keydown="type($event)"
        @blur="loseFocus"
        ></select>
    <span
      v-if="inputPad.element"
      id="fake-cursor"
      :style="{ ...inputStyle, 'margin-left': textLength + 'px'}"
      />
    <div id="text-length" :ref="'text-length'" :style="{ 'font-size': inputStyle['font-size'] }" >{{ inputPad.element ? inputPad.item[inputPad.property] : '' }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ON_INPUT_PAD_BLUR, SET_INPUT_PAD_LENGTH } from '@/store/mutation-types';
import { ON_INPUT_PAD } from '@/store/action-types';
import CommonService from '@/services/CommonService';
export default {
  name: 'InputPadHolder',
  computed: {
    ...mapState({
      inputHolderFocusing: state => state.inputPad.inputHolderFocusing,
      inputPad: state => state.inputPad.currentInputPad,
      textLength: state => state.inputPad.textLength,
    }),
    inputStyle() {
      return CommonService.getInputPadStyle(this.inputPad.element);
    },
  },
  watch: {
    inputHolderFocusing(newState) {
      if (newState && !this.isMobile()) {
        this.$refs['input-holder'].focus();
      }
      this.$forceUpdate();
    },
  },
  methods: {
    type(event) {
      if (this.inputHolderFocusing !== 0) {
        this.$store.dispatch(ON_INPUT_PAD, event.key);
      }
    },
    loseFocus() {
      this.$store.commit(ON_INPUT_PAD_BLUR);
    },
    isMobile() {
      return CommonService.checkMobile();
    },
  },
  mounted() {
    this.$store.commit(SET_INPUT_PAD_LENGTH, this.$refs['text-length']);
  },
};
</script>
